export default class Cursor{
  // x = 0;
  // y = 0;
  // type = 'right';
  // radius = 50;

  constructor(x, y, type, radius, creationTimestamp){
    this.x = x;
    this.y = y;
    this.type = type || "right";
    this.radius = radius != undefined ? radius : 50;
    this.creationTimestamp = creationTimestamp;
  }
}